// extracted by mini-css-extract-plugin
export default {"SpeakerDetails":"SpeakerDetails-module-aa3d85701558ca69fbd3","avatar":"SpeakerDetails-module-a0a21180d2abd4b8d93f"};